export const CONTROLS_OPEN = 'createPostControlsOpen';
export const CONTROLS_CLOSE = 'createPostControlsClose';
export const CONTROLS = 'createPostControls';
